import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, Output, QueryList, ViewChild, ViewChildren, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import _ from 'lodash';
import * as Constants from '../../../models/Constants';
import { AgentInteractionService } from 'src/app/services/agent-interaction.service';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';


const moment = _rollupMoment|| _moment;
// added code to format date in text box- e.g - May-30-2023
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styleUrls: ['./dashboard-filter.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class DashboardFilterComponent implements OnInit {
  @Input('autofocus') autofocus: boolean = true;
  // range -- getting start & end Date from datepicker
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  today = new Date();
  startDate!: Date;
  minDate = this.range.value.start;
  maxRange = moment();

  @ViewChildren("channelLists") channelLists: QueryList<ElementRef> | undefined;
  
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.range.value.start;
    let afterToday = moment(this.minDate, "MMM-DD-YYYY").add(6, 'days').isAfter(moment(), 'day');
    if (afterToday) {
      this.maxRange = moment();
    }
    else {
      this.maxRange = moment(this.minDate, "MMM-DD-YYYY").add(6, 'days');
    }


  }

  iconConfig: { iconName: string; iconType: string; };
  clearAllClicked: boolean = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  clientValue = new FormControl('');
  topicValue = new FormControl('');
  filteredClient: Observable<string[]>;
  filteredTopic: Observable<string[]>;
  selectedClients: string[] = [];
  selectedTopics: string[] = [];
  allClients: string[] = [];
  allTopics: string[] = [];
  selectedChannels: string[] = [];
  isMaxTopics: boolean = false;
  isMaxClient: boolean = false;
  agentIHChannelList: string[] = ['Call', 'Chat', 'Transfer', 'Additional Account'];

  @ViewChild('topicInput') topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('clientInput') clientInput!: ElementRef<HTMLInputElement>;


  constructor(public rootScope: RootScopeService,
    public agentInteractionService: AgentInteractionService,
    public apiService: ApiService,
    public dialog: MatDialog,) {

    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal'
    }

    this.filteredTopic = this.topicValue.valueChanges.pipe(
      map((topic: string | null) => ((topic) ? this.filterTopicList(topic) : this.allTopics.slice())),
    );

    this.filteredClient = this.clientValue.valueChanges.pipe(
      startWith(null),
      map((client: string | null) => (client ? this.filterClientList(client) : this.allClients.slice())),
    );

    this.topicList();
    this.clientList();
    const todayDate = new Date();
    this.startDate = new Date(todayDate.setMonth(todayDate.getMonth() - 6));

  }

  ngOnInit(): void {
    this.rootScope.agenIneractionData.isAgentClientAccess = true
    this.setFilterFormValue();
    if (this.selectedClients?.length > 0) {
      this.selectedClients.forEach(x => {
        if (x) this.filterClientList(x)
      })
    }
    if (this.selectedTopics?.length > 0) {
      this.selectedTopics.forEach(x => {
        if (x) this.filterTopicList(x)
      })
    }

    this.createCheckboxList();

  }


  /** 
* method to set filter data after retaining data.
* @author :Amarjeet Kumar
*/
  setFilterFormValue() {
    if (this.agentInteractionService.agentFilterFormData) {
      let data = _.cloneDeep(this.agentInteractionService.agentFilterFormData);
      if (data) {
        this.range = new FormGroup({
          start: new FormControl<Date | null>(data.range?.startDate ? new Date(data.range?.startDate) : null),
          end: new FormControl<Date | null>(data.range?.endDate ? new Date(data.range?.endDate) : null),
        });
        this.selectedClients = data?.clientList;
        this.selectedChannels = data?.channelList;
        this.selectedTopics = data?.topicList;
        this.setDate();
      }
    }
  }

  /** 
  * closeFilter()- method to close Agent Filter popup.
  * @author :Amarjeet Kumar
  */
  closeFilter() {
    this.rootScope.openFilterDialog = false;
  }

  /** 
   * method to add topic using enter button into array of selected topics .
   * @author :Amarjeet Kumar
   */
  addTopic(event: MatChipInputEvent): void {
    if (this.allTopics.includes(event?.value)) {
      this.selectedTopics.push(event.value);
    }
    event?.chipInput!.clear();
    this.topicValue.setValue(null);
  }

  /** 
  * method to add Client using enter button into array of selected Clients .
  * @author :Amarjeet Kumar
  */
  addClient(event: MatChipInputEvent): void {
    if (this.allClients.includes(event?.value)) {
      this.selectedClients.push(event.value);
    }
    event?.chipInput!.clear();
    this.clientValue.setValue(null);
  }

  /** 
   * this.selectedTopics -- Keeping array of selected topics .
   * @author :Amarjeet Kumar
   */
  selectedTopic(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTopics?.length < 3) {
      this.selectedTopics.push(event?.option.viewValue);
      this.isMaxTopics = false;
    }
    else {
      this.isMaxTopics = true;
    }
    this.topicInput.nativeElement.value = '';
    this.topicValue.setValue(null);
  }


  /** 
 * this.selectedClient -- Keeping array of selected Client .
 * @author :Amarjeet Kumar
 */
  selectedClient(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedClients?.length < 3) {
      this.selectedClients.push(event?.option.viewValue);
      this.isMaxClient = false;
    }
    else {
      this.isMaxClient = true;
    }
    this.clientInput.nativeElement.value = '';
    this.clientValue.setValue(null);
  }

  /** 
  * method to remove topic from array of selected Topics .
  * @author :Amarjeet Kumar
  */
  removeTopic(topic: string): void {
    const index = this.selectedTopics.indexOf(topic);
    if (index >= 0) {
      this.selectedTopics.splice(index, 1);
      this.allTopics.push(topic);
      this.updateTopicList()
      this.isMaxTopics = false;
      this.topicInput.nativeElement.value = '';
      this.topicValue.setValue(null);
    }
  }

  /** 
  * method to remove Client from array of selected Clients .
  * @author :Amarjeet Kumar
  */
  removeClient(client: string): void {
    const index = this.selectedClients.indexOf(client);
    if (index >= 0) {
      this.selectedClients.splice(index, 1);
      this.allClients.push(client);
      this.updateClientList()
      this.isMaxClient = false;
      this.clientInput.nativeElement.value = '';
      this.clientValue.setValue(null);
    }
  }

  /** 
   * this.allTopics -- updating all topic list .
   * @author :Amarjeet Kumar
   */
  filterTopicList(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (this.allTopics.find(x => x.toLowerCase() == filterValue) && this.selectedTopics?.length < 3)
      return this.allTopics = this.allTopics.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allTopics.filter(topic => topic.toLowerCase().includes(filterValue));
  }

  /** 
  * method to create unique topic list from IH service .
  * @author :Amarjeet Kumar
  */
  topicList() {
    let topicList: any = [];
    if (this.agentInteractionService.agentIHFilterDataMap && this.agentInteractionService.agentIHFilterDataMap?.data?.length > 0) {
      let topic;
      this.agentInteractionService.agentIHFilterDataMap?.data?.forEach((x: any) => {
        topic = this.topicFormat(x.topic)
        if (topic)
          topicList.push(topic)
      })
    }
    this.allTopics = _.uniq(topicList);
    this.updateTopicList();
  }

  /** 
    * method to format topic list e.g. "topic>>subTopic" .
    * @author :Amarjeet Kumar
    */
  topicFormat(topic) {
    if (topic?.includes(Constants.TOPIC_ARROW)) {
      let text = topic.split(Constants.TOPIC_ARROW).splice(1);
      text = ((text.toString()).replace(',', Constants.TOPIC_ARROW)).trim();
      return text;
    }
  }

  /** 
 * this.filteredTopic -- updating Topics dropdown list .
 * @author :Amarjeet Kumar
 */
  updateTopicList() {
    this.filteredTopic = this.topicValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterTopicList(topic) : this.allTopics.slice())),
    );
  }

  /** 
  * this.allTopics -- updating all topic list .
  * @author :Amarjeet Kumar
  */
  filterClientList(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (this.allClients.find(x => x.toLowerCase() == filterValue) && this.selectedClients?.length < 3)
      return this.allClients = this.allClients.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allClients.filter(topic => topic.toLowerCase().includes(filterValue));
  }

  /** 
  * method to create unique client list from Agent IH service .
  * @author :Amarjeet Kumar
  */
  clientList() {
    let clientList: any = [];
    if (this.agentInteractionService.agentIHFilterDataMap && this.agentInteractionService.agentIHFilterDataMap?.data?.length > 0) {

      this.agentInteractionService.agentIHFilterDataMap?.data?.forEach((x: any) => {
        clientList.push(x.clientName)
      })
    }
    this.allClients = _.uniq(clientList);
    this.updateClientList();
  }



  /** 
* this.updateClientList -- updating Clients dropdown list .
* @author :Amarjeet Kumar
*/
  updateClientList() {
    this.filteredClient = this.clientValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterClientList(topic) : this.allClients.slice())),
    );
  }

  /** 
   * this.selectedChannels -- Keeping array of selected channels .
   * @author : Sultan
   */
  
  channelList(event: any): void {
    const payload = (event as CustomEvent<{
      uuid: string;
      checked: boolean;
      value: string;
    }>).detail;

    this.rootScope.awldsAgentIHChannelLists = this.rootScope.awldsAgentIHChannelLists.map((item) =>
      item.uuid == payload.uuid ? { ...item, checked: payload.checked } : item
    );

    this.selectedChannels = this.rootScope.awldsAgentIHChannelLists
      .filter((item) => item.checked)
      .map((item) => item.labelText.toLowerCase());
  }


  /**
  * Method to reset filter form value.
  * @author :Amarjeet Kumar
  */
  clearAll() {

    this.range.reset();
    this.selectedChannels = [];
    this.selectedClients = [];
    this.selectedTopics = [];
    this.isMaxClient = false;
    this.isMaxTopics = false;
    this.channelLists?.forEach((data: any) => data._checked = false);
    this.allClients = [];
    this.allTopics = [];

    this.clientList();
   // Reset checkbox values in rootScope
  if (this.rootScope.awldsAgentIHChannelLists) {
    this.rootScope.awldsAgentIHChannelLists = this.rootScope.awldsAgentIHChannelLists.map(item => ({
      ...item,
      checked: false
    }));
  }
    this.topicList();
    this.clearAllClicked = true;

  }

  /**
    *apply() - Method to apply filter on Agent IH Data.
    * @author :Amarjeet Kumar
    */
  apply() {

    //filter from date
    if (this.range && this.range.value && (this.range.value.start && this.range.value.end)) {

      let agentFilterObj = {
        // userLanId: sessionStorage.getItem("lanId"),
        fromDate: moment(this.range.value.start).year() + '-' + (moment(this.range.value.start).month() + 1).toString().padStart(2, '0') + '-' + moment(this.range.value.start).date().toString().padStart(2, '0'),
        toDate: moment(this.range.value.end).year() + '-' + (moment(this.range.value.end).month() + 1).toString().padStart(2, '0') + '-' + moment(this.range.value.end).date().toString().padStart(2, '0')
      };
      this.fetchAgentIHData(agentFilterObj);
    }
    else if (this.clearAllClicked) {

      // let agentFilterObj = {
      //   userLanId: sessionStorage.getItem("lanId")
      // };
      this.fetchAgentIHData();
    }
    else {
      this.agentFilter();
    }

  }

  /**
  *agentFilter() - Method to apply filter on Agent IH Data for clients, topics & channels.
  * @author :Amarjeet Kumar
  */
  agentFilter() {
    let tempFilterData = this.agentInteractionService.agentIHFilterDataMap.data;
    //filter from clients
    if (this.selectedClients && this.selectedClients.length > 0) {
      tempFilterData = tempFilterData?.filter((x: any) => this.selectedClients.includes(x.clientName))
    }

    // filter from topics
    if (this.selectedTopics && this.selectedTopics.length > 0) {
      tempFilterData = tempFilterData?.filter((x: any) => this.selectedTopics.find(v => x?.description?.includes(v)))
    }

    //filter from channels
    if (this.selectedChannels && this.selectedChannels.length > 0) {
      tempFilterData = tempFilterData?.filter((x: any) => this.selectedChannels.includes(x.channelForFilter.toLowerCase()))
    }

    // Retaining Agent filter form data
    let agentFilterFormData: any = {
      range: { startDate: this.range.value.start, endDate: this.range.value.end },
      clientList: this.selectedClients,
      channelList: this.selectedChannels,
      topicList: this.selectedTopics,
    }

    this.agentInteractionService.agentFilterFormData = agentFilterFormData;
    this.agentInteractionService.agentInteractionHistoryTableData = new MatTableDataSource(tempFilterData);
    this.rootScope.isAgentFilterApplied = true;

    // added condition to reset IH list Filter in case of blank form data 
    if (!this.range.value.end && !this.range.value.start && this.selectedChannels?.length == 0 && this.selectedClients?.length == 0 && this.selectedTopics?.length == 0) {
      this.rootScope.isAgentFilterApplied = false;
    }


    this.rootScope.openFilterDialog = false;
  }

  /**
  * Below method is used to fetch agent Interaction from 
  * Document DB
  */
  fetchAgentIHData(agentFilterObj?: any) {

    this.apiService.getAgentInteractionData(agentFilterObj).subscribe({
      next: (data: any) => {
        if (data['data'] && data['data'].length > 0) {
          this.agentInteractionService.modifyAgentIHViewData(data['data']);

        } else {
          console.log('No Data found when getAgentInteractionData called', data);
          this.rootScope.openFilterDialog = false;
          this.agentInteractionService.agentInteractionHistoryTableData = new MatTableDataSource([]);
          this.agentInteractionService.agentIHFilterDataMap = new MatTableDataSource([]);
          // this.rootScope.isAgentFilterApplied = true;
        }
        this.agentFilter();
        this.clearAllClicked = false;
      },
      error: (error) => {
        // Handle errors
        this.clearAllClicked = false;
        console.error('Error occurred:', error);
      }
    });
  }

  /**
  *setDate() - Method to retain 7 days date valiadation logic during retaining date.
  * @author :Amarjeet Kumar
  */
  setDate() {
    this.minDate = this.range.value.start;
    let afterToday = moment(this.minDate, "MMM-DD-YYYY").add(6, 'days').isAfter(moment(), 'day');
    if (afterToday) {
      this.maxRange = moment();
    }
    else {
      this.maxRange = moment(this.minDate, "MMM-DD-YYYY").add(6, 'days');
    }
  }


    /**
     * Creates a checkbox list for agent IH channels if no channels are currently selected.
     * Maps the agentIHChannelList to a structured format with checkbox properties and assigns
     * it to rootScope.awldsAgentIHChannelLists. Each item includes checked state, disabled state,
     * label text, initial value, and a unique identifier.
     * 
     */
  createCheckboxList() {

    if (this.selectedChannels.length > 0) {
      return;
    }

    this.rootScope.awldsAgentIHChannelLists = this.agentIHChannelList?.map((item, index) => ({
      checked: false,
      disabled: false,
      labelText: item,
      initialValue: item,
      uuid: `interest-checkbox-${index}`
    }));
  }

    

}
